import React, {createContext, useState, useMemo, useContext} from "react";
import {generateUUIDv4} from "../../functions/generateRandomId";
// import someManager from "../some-manager";

export const AuthDataContext = createContext(null);

const initialAuthData = {};

const AuthDataProvider = props => {
    const [authData, setAuthData] = useState(JSON.parse(localStorage.getItem("user")) || initialAuthData);

    const onLogout = () => setAuthData(initialAuthData);

    const onLogin = newAuthData => {
        setAuthData(newAuthData);
        localStorage.setItem("correlation-id", generateUUIDv4());
    };

    const authDataValue = useMemo(() => ({...authData, onLogin, onLogout}), [authData]);

    return <AuthDataContext.Provider value={authDataValue} {...props} />;
};

export const useAuthDataContext = () => useContext(AuthDataContext);

export default AuthDataProvider;
